import React, { FC } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { GrayCard, RefValue } from "@/components/molecules";
import { GrayCardProps } from "@/components/molecules/Cards/GrayCard/GrayCard";

import { CompanyFormType } from "../../../../formType";
import { StyledCardItem, StyledCardList } from "../styled";

const ContactCard: FC<GrayCardProps> = ({ onEdit }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<CompanyFormType>();

    const { fields: phones } = useFieldArray({
        control,
        name: "contact.telephoneNumbers",
    });

    const { fields: emails } = useFieldArray({
        control,
        name: "contact.emailAddresses",
    });

    return (
        <GrayCard title={t("Common.Contact")} onEdit={onEdit}>
            <StyledCardList>
                <StyledCardItem $size={3}>
                    <span>{t("Common.Phone")}</span>
                    <ul style={{ margin: 0 }}>
                        {phones.map((phone) => (
                            <li key={phone.number}>
                                {phone.description ? (
                                    <>
                                        {`${phone.description}:`}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                <RefValue table="phoneNumberType" value={phone.type} />: {phone.number}
                            </li>
                        ))}
                    </ul>
                </StyledCardItem>
                <StyledCardItem $size={3}>
                    <span>{t("Common.Email")}</span>
                    <ul style={{ margin: 0 }}>
                        {emails.map((email) => (
                            <li key={email.email}>
                                {email.description ? (
                                    <>
                                        {`${email.description}:`}
                                        <br />
                                    </>
                                ) : (
                                    ""
                                )}
                                {email.email}
                            </li>
                        ))}
                    </ul>
                </StyledCardItem>
            </StyledCardList>
        </GrayCard>
    );
};

export default ContactCard;
